module.exports = __webpack_public_path__ + "static/media/3.63e63533.jpg";